import type { User } from "../app/api.js";
import { request } from "./client.js";

export type SessionResponse = { authenticated: boolean; user: User | null };

export const authApi = {
  session: () => request<SessionResponse>("/api/v1/auth/session/"),
  logout: () => request<void>("/api/v1/auth/logout/", { method: "POST", body: "{}" }),
};
